import React from 'react'
import StepIndicator from 'components/dashboard/integrations/containers/CarrierWizard/components/StepIndicator'
import ContinueButton from './ContinueButton'
import BackButton from './BackButton'
import BottomNotes from './BottomNotes'
import AccountInfoFormFields from './AccountInfoFormFields'
import styles from './UPSAccountWizard.module.css'

// Default number of steps in the UPS account wizard flow
const TOTAL_STEPS = 3

export function AccountInfoStep(props) {
    const {
        title,
        hasValidationErrors,
        onContinueClick,
        withInvoiceField = true,
        totalSteps = TOTAL_STEPS,
        currentStep = 2,
        disabled = false,
        carrier = {},
    } = props

    const isReauthentication = carrier.required_oauth_migration

    return (
        <>
            <BackButton />
            {title ? <h3>{title}</h3> : <h3>UPS&reg; Validation</h3>}
            <StepIndicator total={totalSteps} current={currentStep} />

            <div className={styles.helpBox}>
                {isReauthentication ? (
                    <p className={styles.helpBoxText}>
                        UPS has updated their APIs to use a new security
                        protocol, OAuth 2.0. To continue to receive negotiated
                        UPS rates and services via ShipperHQ, you'll need to
                        re-authorize the connection to UPS. This process only
                        takes a few minutes to complete. Please review our{' '}
                        <a
                            href="https://docs.shipperhq.com/ups-carrier-setup/#Required_Information"
                            target="_blank"
                            className={styles.helpBoxLink}
                        >
                            Help Docs
                        </a>{' '}
                        for more details.
                    </p>
                ) : (
                    <p className={styles.helpBoxText}>
                        Please ensure the UPS account information entered below
                        is associated to an{' '}
                        <a
                            href="https://docs.shipperhq.com/ups-carrier-setup/#Required_Information"
                            target="_blank"
                            className={styles.helpBoxLink}
                        >
                            active UPS.com account
                        </a>
                    </p>
                )}
            </div>

            <h4>UPS Account Information</h4>
            <AccountInfoFormFields withInvoiceField={withInvoiceField} />
            <ContinueButton
                disabled={disabled}
                errors={hasValidationErrors}
                onClick={onContinueClick}
            />
        </>
    )
}
